import script from "./Contacts.vue?vue&type=script&setup=true&lang=js"
export * from "./Contacts.vue?vue&type=script&setup=true&lang=js"

import "./Contacts.vue?vue&type=style&index=0&id=956b23f2&lang=css"

const __exports__ = script;

export default __exports__